import * as Yup from 'yup';
import {FormPage} from 'api';

export default (page: FormPage) => {
  let validationSchema: {[key: string]: any} = {};

  page?.formBlocks.forEach((block) => {
    let schema = null;

    switch (block.formBlockable.__typename) {
      case 'FormBlockFieldStandard':
        switch (block.formBlockable.standardFieldType) {
          case 'name':
            schema = Yup.object().shape({
              first_name: block.formBlockable.isRequired
                ? Yup.string().required('必須項目です')
                : Yup.string(),
              last_name: block.formBlockable.isRequired
                ? Yup.string().required('必須項目です')
                : Yup.string(),
            });
            break;
          case 'email':
            schema = block.formBlockable.isRequired
              ? Yup.string()
                  .email('メールアドレスの形式で入力してください')
                  .required('必須項目です')
              : Yup.string().email('メールアドレスの形式で入力してください');
            break;
          case 'account_name':
          case 'web_site':
          case 'section':
          case 'section_position':
          case 'address':
          case 'telephone_number':
          case 'account_telephone_number':
            schema = block.formBlockable.isRequired
              ? Yup.string().required('必須項目です')
              : Yup.string();
            break;
        }
        break;
      case 'FormBlockFieldCustomizeItem':
        switch (block.formBlockable.poolProspectCustomizeItem.dataType) {
          case 'text':
            schema = block.formBlockable.isRequired
              ? Yup.string().required('必須項目です')
              : Yup.string();
            break;
          case 'number':
            schema = block.formBlockable.isRequired
              ? Yup.number()
                  .nullable()
                  .transform((curr, orig) => (orig === '' ? null : curr))
                  .required('必須項目です')
              : Yup.number()
                  .nullable()
                  .transform((curr, orig) => (orig === '' ? null : curr));
            break;
          case 'date':
            schema = block.formBlockable.isRequired
              ? Yup.string()
                  .nullable()
                  .transform((curr, orig) => (orig === '' ? null : curr))
                  .required('必須項目です')
              : Yup.string()
                  .nullable()
                  .transform((curr, orig) => (orig === '' ? null : curr));
            break;
          case 'select':
            schema = block.formBlockable.isRequired
              ? Yup.array()
                  .of(Yup.string())
                  .transform((curr, orig) => (orig === false ? [] : curr))
                  .transform((curr, orig) =>
                    Array.isArray(curr) ? curr : [orig],
                  )
                  .min(1, '必須項目です')
              : Yup.array()
                  .of(Yup.string())
                  .nullable()
                  .transform((curr, orig) => (orig === '' ? null : curr));
            break;
        }
        break;
      case 'FormBlockFieldOther':
        switch (block.formBlockable.dataType) {
          case 'text':
            schema = block.formBlockable.isRequired
              ? Yup.string().required('必須項目です')
              : Yup.string();
            break;
          case 'number':
            schema = block.formBlockable.isRequired
              ? Yup.number()
                  .nullable()
                  .transform((curr, orig) => (orig === '' ? null : curr))
                  .required('必須項目です')
              : Yup.number()
                  .nullable()
                  .transform((curr, orig) => (orig === '' ? null : curr));
            break;
          case 'date':
            schema = block.formBlockable.isRequired
              ? Yup.string()
                  .nullable()
                  .transform((curr, orig) => (orig === '' ? null : curr))
                  .required('必須項目です')
              : Yup.string()
                  .nullable()
                  .transform((curr, orig) => (orig === '' ? null : curr));
            break;
          case 'select':
            if (block.formBlockable.fieldType === 'radio') {
              schema = block.formBlockable.isRequired
                ? Yup.string().nullable().required('必須項目です')
                : Yup.string().nullable();
            } else {
              schema = block.formBlockable.isRequired
                ? Yup.array()
                    .of(Yup.string())
                    .transform((curr, orig) => (orig === false ? [] : curr))
                    .transform((curr, orig) =>
                      Array.isArray(curr) ? curr : [orig],
                    )
                    .min(1, '必須項目です')
                : Yup.array()
                    .of(Yup.string())
                    .nullable()
                    .transform((curr, orig) =>
                      Array.isArray(curr) ? curr : [orig],
                    );
            }
            break;
        }
        break;
    }

    validationSchema[block.id] = schema;
  });

  return Yup.object().shape(validationSchema);
};
